module.exports = __webpack_public_path__ + "static/st2-8-892300ea839adda311f3e3ab16739394.jpg";